import {useHistory} from 'react-router-dom'
import {useGroupedColorVariation} from '../../hooks'
import PropTypes from 'prop-types'
import React from 'react'
import ColorVariationSwatchGroup from './color-variation-swatch-group'

const GroupedColorVariationSelection = ({
    product,
    loading,
    onChange,
    isProductASet,
    onHoverChange
}) => {
    const history = useHistory()

    const colorVariation = useGroupedColorVariation(product, isProductASet)

    if (!colorVariation?.groups?.length) {
        return null
    }

    return (
        <>
            {colorVariation.groups.map(({values, label, displayName}) => (
                <ColorVariationSwatchGroup
                    key={label}
                    currentProductId={product.id}
                    loading={loading}
                    onChange={(value, href) => {
                        // skip change if no href or the same value is selected - the latter because of the onChange
                        // trigger, which expects a change on the product, but the same selected variant would not trigger a change
                        if (!href || value === colorVariation.selectedValue.value) return
                        history.replace(href)
                        onChange?.(value, href)
                    }}
                    onHoverChange={onHoverChange}
                    label={label}
                    value={colorVariation.selectedValue.value}
                    displayName={displayName}
                    colorVariationValues={values}
                />
            ))}
        </>
    )
}

GroupedColorVariationSelection.propTypes = {
    product: PropTypes.object,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    isProductASet: PropTypes.bool,
    onHoverChange: PropTypes.func
}

export default GroupedColorVariationSelection
